import React from "react";
import {connect} from "react-redux";
import {AutoComplete, Card} from "antd";
import * as types from "../../constants/ActionTypes";
import {fetchCallCenterIvsVin, fetchCustomer, fetchVehicleProperties} from "../../actions/callCenterActions";
import {getVin} from "../../selectors/createAppointmentRequest";
import {getFormattedIvsVin} from "../../selectors/ivsCallCenterResults";
import DealerSelection from "./dealer/DealerSelection";
import Constants from "../../services/Constants";
import {FormattedMessage} from "react-intl";
import SAInput from "../common/input/SAInput";
import lodash from "lodash";

const Option = AutoComplete.Option;

class VinInformation extends React.Component {

  constructor(props) {
    super(props);
    const vehicle = {};
    this.state = {
      vehicle
    };
  }

  getBrand = (vin) => {
    switch (vin) {
      case "WBA"://BMW
      case "X4X"://BMW (AvtoTor (Russia, BMW SKD))
      case "4US"://BMW USA
      case "WBS":// BMW M
        return Constants.BRAND_BMW.value;
      case "WBY":
        return Constants.BRAND_BMW_I.value;
      case "WBW":
      case "WMW":
        return Constants.BRAND_MINI.value;
      default:
        return undefined;
    }
  }

  handleChangeValue = (value) => {
    const {vehicle} = this.state;
    vehicle.vin = value;
    vehicle.brand = this.getBrand(value.slice(0, 3));
    this.setState({vehicle});
    this.props.dispatchSaveGeneralInformation(vehicle);
  };

  handleIvsResultSelect = (vin) => {
    const {vin7, ...vehicle} = this.props.ivs.get(vin);
    this.setState({vehicle});
    this.props.dispatchSaveGeneralInformation(vehicle);
    this.props.dispatchFetchVehicleProperties(vin);
    this.props.dispatchFetchCustomerInformation(vin);
  };

  onIvsLookup = lodash.debounce((vin) => {
    const formattedVin = vin.replace(/[^0-9A-Za-z]/g, '');
    this.handleChangeValue(formattedVin);
    this.props.dispatchLookupVin(formattedVin);
  }, 500);

  validateVin = () => {
    const {vin} = this.props;
    if (!vin) {
      return {message: 'error.not.null'};
    }
    if (vin.length > 2 && !Constants.SUPPORTED_WMIS.includes(vin.slice(0, 3))) {
      return {message: 'error.vin.unsupported'};
    }
    if (vin.length < 17) {
      return {message: 'error.vin.invalid'};
    }
    return null;
  }

  render() {
    const {vin, ivs} = this.props;
    const options = [];
    ivs.forEach((result, ivsResult) => options.push(
      <Option key={result.vin}
              value={ivsResult}>{`${result.vin} ${result.brand} ${result.model} ${result.modelCode} ${result.color}`}</Option>
    ));

    return (
      <React.Fragment>
        <Card title={<h3><FormattedMessage id="summary.vin"/></h3>} bordered={false} style={{width: '100%'}}>
          <div className="wrap">
            <div className="content">
              <AutoComplete onSearch={this.onIvsLookup}
                            defaultValue={vin}
                            dropdownMatchSelectWidth={false}
                            onSelect={this.handleIvsResultSelect}
                            dropdownStyle={{width: 600}}
                            optionLabelProp={"value"}
                            dataSource={options}
                            style={{width: '100%'}}>
                <SAInput
                  name={'vin'}
                  className={'uppercase'}
                  value={vin}
                  maxLength={17}
                  error={this.validateVin()}
                  style={{width: '35%'}}
                />
              </AutoComplete>
            </div>
          </div>
        </Card>
        <DealerSelection/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  vin: getVin(state),
  ivs: getFormattedIvsVin(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchCustomerInformation: payload => dispatch(fetchCustomer(payload)),
  dispatchFetchVehicleProperties: payload => dispatch(fetchVehicleProperties(payload)),
  dispatchLookupVin: payload => dispatch(fetchCallCenterIvsVin(payload)),
  dispatchSaveGeneralInformation: (params) => dispatch({type: types.SAVE_GENERAL_INFORMATION, params})
});

export default connect(mapStateToProps, mapDispatchToProps)(VinInformation);
